import React from 'react'
import "./trackRecord.scss";

const TrackRecord = () => {
  // Public ID: 11587076
  // Note: 'color=black' helps the widget blend into your dark theme
  const widgetUrl =
    "https://widgets.myfxbook.com/widgets/11587076/large.html?color=black";
  const externalLink = "https://www.myfxbook.com/portfolio/gold-ai/11587076";
  return (
    <div className="__fw">
      <section className="performance-section">
        <div className="__mw">
          <div className="perf-header">
            <div className="perf-badge">
              <span className="perf-dot"></span> Verified Live Results
            </div>
            <h2>
              Institutional <span>Performance Analytics</span>
            </h2>
            <p>
              Transparency is our core pillar. Track our Gold AI's growth
              through a fully verified, independent third-party audit.
            </p>
          </div>

          <div className="perf-terminal">
            <img src={require("../../img/img_1.png")} alt="" />
            <br />
            <img src={require("../../img/img_2.png")} alt="" />
          </div>

          <div className="perf-features">
            <div className="feature">
              <strong>Track Record</strong>
              <span>Verified by MyFxBook</span>
            </div>
            <div className="feature">
              <strong>Trading Privilege</strong>
              <span>Verified</span>
            </div>
            <div className="feature">
              <strong>Broker</strong>
              <span>IC Markets (Real)</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TrackRecord
